import { combineReducers } from '@reduxjs/toolkit'
import departmentReducer from './department'
import jobPositionReducer from './job-position'
import jobTitleReducer from './job-title'

const combinedReducer = combineReducers({

  jobPosition: jobPositionReducer,
  jobTitles: jobTitleReducer,
  departments: departmentReducer,

})

export default combinedReducer
